export const GET_TOP = 'getTop'
export const TOP_FONT_SCALE = 'topFontScale'
